module.exports = __webpack_public_path__ + "static/media/Group_1597880740@2x.e9e69b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group_1597880740@2x.png
// module id = 1213
// module chunks = 0